import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { ContentLoader, PrimaryButton } from '@weave/design-system';

import LogoIcon from 'assets/wv-icon-logo.svg';
import { useAuth } from 'auth/auth-provider';
import { FORM_SUBMISSION_ROOT } from 'shared/constants/paths';
import * as styles from './sign-in.styles';
import {REACT_APP_SIGN_IN_METHOD} from "../../shared/constants";
import {authnClient} from "@weave/auth";

const SignIn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const history = useHistory();

  const oktaSignIn = async () => {
    authnClient.signIn();
  };

  useEffect(() => {
    /* check if authenticated and they land on this page redirect */
    if (user && history.location.pathname !== '/login/callback') {
      history.push(FORM_SUBMISSION_ROOT);
    }
  }, [user]);

  useEffect(() => {
    authnClient.changeAuthMethod(REACT_APP_SIGN_IN_METHOD)
    if (history.location.pathname.includes('callback')) setIsLoading(true);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div css={styles.container}>
      <ContentLoader show={isLoading} />
      <div css={styles.innerContainer}>
        <LogoIcon />
        <div css={styles.divider} />
        <PrimaryButton
          disabled={isLoading}
          css={styles.updatedButtonStyles}
          onClick={oktaSignIn}
        >
          Sign In
        </PrimaryButton>
      </div>
    </div>
  );
};

export default SignIn;
